<template>
    <casa-form :idBusiness="idBusiness" :idCasa="idCasa" :pag="pag" :idSubproducto="idSubproducto"
               :desdeSubproducto="desdeSubproducto"></casa-form>
</template>

<script>
    import CasaForm from '../../../Widgets/Casas/CasaForm.vue'
    import swal from 'sweetalert2'
    export default {
        components: {
            CasaForm
        },
        data() {
            return {
                idBusiness: this.$route.params.idBusiness,
                idCasa: this.$route.params.idCasa,
                pag: this.$route.params.pag,
                desdeSubproducto: this.$route.params.desdeSubproducto,
                idSubproducto: this.$route.params.idSubproducto
            }
        },
        created() {
            let action = this.idCasa ? this.$i18n.t("editar") : this.$i18n.t("nueva");
            this.$store.dispatch('setNameRoute', action +' '+ this.$i18n.t("casa"));

            this.getRestrictions();
        },
        methods: {

            getRestrictions() {

                var config = {
                    params: {
                        jwt: this.$store.getters.jwt,
                        idBusiness: this.idBusiness,
                        idRestriction: 16,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "general/getRestrictionsByTipo", config)
                    .then(function (response) {

                        if (!response.data.response) {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                            vm.$router.push({
                                name: 'configuracion'
                            })

                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });


            }


        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Configuracion/Casas/Casa.vue